import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MachineLabTestConfigApi } from '../api/machinelabtestconfig.api';
import { switchMap, map } from 'rxjs/operators';

import { MachineLabTestConfigData, MachineLabTestConfig } from '../../../interfaces/masters/machinelabtestconfig' ;
@Injectable()
export class MachineLabTestConfigService extends MachineLabTestConfigData {

    constructor(private api: MachineLabTestConfigApi) {
      super();
    }
  
  
    list(url: string): Observable<MachineLabTestConfig[]> {
      return this.api.list(url);
    }
  
    // getById(url:string): Observable<LabTest>{
    //     return this.api.getById(url);
    // }
  
    // create(url: string, data:LabTest): Observable<LabTest[]> {
    //   return this.api.add(url,data);
    // }
  
    // update(url: string, data:LabTest): Observable<LabTest> {
    //   return this.api.update(url,data);
    // }
  
    
  
    // delete(url: string): Observable<boolean> {
    //   return this.api.delete(url);
    // }
  }
  